module.exports = __webpack_public_path__ + "media/DINPro-Condensed-Bold.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/DINPro-Condensed/DINPro-Condensed-Bold.woff
// module id = 1570
// module chunks = 57